/* global extKey */
// this module creates global functions selectAll() and mapIt() -- VERY MESSY!
import {renderInfo} from './renderInfo.js';

export default function() {
  /* check/un-check all rows in search results list */
  window.selectAll = function(v, f) {
    f = f || 'form1';
    var checkboxes = document.getElementById(f).getElementsByTagName('input');
    [].forEach.call(checkboxes, function(el) {
      el.checked = v;
    });
  };

  /*
    mapIt() gets called from the search results
    it might not have a pidn parameter
    in which case we look for checked check boxes
  */
  window.mapIt = function(pidn) {
    let selectedPIDNs = [];
    extKey.shiftKey = false;
    if (pidn) {
      selectedPIDNs.push(pidn);
    } else {
      let checkboxes = document.getElementById('form1').getElementsByTagName('input');
      [].forEach.call(checkboxes, function(el) {
        if (el.checked) {
          selectedPIDNs.push(el.value);
        }
      });
      if (selectedPIDNs.length === 0) {
        alert('No records are checked, nothing to map.');
        return;
      }
    }
    rwg.selection.clear()

    /* // 2023-12-06 reverting back to GET instead of POST so that all requests to infoTool.php are GETs
    let postData = {
      filter: {
        'pidn': selectedPIDNs
      },
      layers: ['ownership'],
    }
    renderInfo(postData, true)
    */

    let filter = "(pidn in('" + selectedPIDNs.join("','") + "'))"; // eslint-disable-line quotes
    let url = rwg.config.info_url + `filter=${filter}&layers=ownership`

    renderInfo(url, true)
    rwg.tabs.activate('top-map')
  }
}
